import React, { Component } from 'react';
import {
    Nav, NavDropdown, Button
} from 'react-bootstrap';
import { Link } from "gatsby";
import Auth from '../Common/Auth';
import { window, exists } from 'browser-monads'

class AuthProfileButton extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoggedIn: null
        };

        this.auth = new Auth(null);
    }

    handleLogout = () => {
        this.auth.logout((isLoggedOut) => {
            if(isLoggedOut) {
                if(exists(window)) {
                    window.location.href = "/"
                }
            }
        })
    }

    componentDidMount() {
        let self = this

        this.auth.checkServerTokenHandler((isLoggedInParam) => {
            if(isLoggedInParam !== null) {
                self.setState({ isLoggedIn: isLoggedInParam })
            }
        })
    }

    render() { 
        return (
            <Nav>
                { this.state.isLoggedIn !== null && 
                    <div>
                        { this.state.isLoggedIn ? (
                                <span className="user-text-right">
                                    <NavDropdown title="User" id="user-dropdown" className="App-header-dropdown header-text mr-3 sv-ml-3 nav-link">
                                        <NavDropdown.Item>
                                            <Link to="/profile"
                                                className="header-text mr-3 sv-ml-3 nav-link">
                                                Profile
                                            </Link>
                                        </NavDropdown.Item>
                                        <NavDropdown.Item>
                                            <Button variant="link" onClick={this.handleLogout}
                                                className="header-text mr-3 sv-ml-3 nav-link">
                                                Logout
                                            </Button>
                                        </NavDropdown.Item>
                                    </NavDropdown>
                                </span>
                            ):(
                                <span className="text-right">
                                    <Link to="/login"
                                        className="header-text mr-3 sv-ml-3 nav-link">
                                        Login
                                    </Link>
                                </span>
                            )
                        }
                    </div>
                }
            </Nav>
        )
    }
}


export default AuthProfileButton;
